import { EntityName } from 'record-it-time-common/EntityName';
import { EntityRepositoryByEntityName } from '../../classes/entities/AppEntityManager';
import { useEntityManager } from './useEntityManager';

export function useEntityRepository<TEntityName extends EntityName>(
  entityName: TEntityName
): EntityRepositoryByEntityName[TEntityName] {
  const { entityManager } = useEntityManager();
  return entityManager.entityRepositoryContainer.getByEntityName(entityName);
}
